module.exports = __webpack_public_path__ + "static/media/Benifits3.23308d48.webp";